export default __webpack_public_path__ + "static/media/boot.db027662.png";